( function () {
    'use strict';
    espresso.dealersearch = {};
    espresso.maps = {};
    espresso.maps.init = function (){};
    espresso.dealersearch.settings = {
        fields: {
            jInput: jQuery( '#js-e-map-search-input' ),
            jSubmit: jQuery( '#js-e-map-search-submit' ),
            jReset: jQuery( '#js-e-map-search-reset' ),
            jForm: jQuery('#fagtek-dealer-search')
        }
    };
    /// Init dealer search logic
    espresso.dealersearch.init = function () {
            espresso.dealersearch.attachEvents();
    };
    /// Attach events to dom elements
    espresso.dealersearch.attachEvents = function () {
        espresso.dealersearch.settings.fields.jForm.validate({
          submitHandler: function(form, event) {
            event.preventDefault();
            var inputVal = espresso.dealersearch.settings.fields.jInput.val();
            espresso.dealersearch.performSearch(inputVal);
        },
        rules: {
          'dealerq': {
            required: true,
            minlength: 4,
            maxlength: 6,
            number: true
          }
        },
        messages: {
            'dealerq': 'Indtast venligst et gyldigt postnummer'
        }
    });
    };
    espresso.dealersearch.performSearch = function ( originalSearchValue ) {
        jQuery('#js-e-map-list').removeClass('hidden');
        jQuery('#js-map-list-no-results').addClass('hidden');
        jQuery('#js-map-list-results-headline').addClass('hidden');
        jQuery('.js-e-map-list-item').addClass('hidden');
        var dealerCount = 0;
        jQuery( '.js-e-map-list-item' ).each(function() {
            var zipString = jQuery(this).data('zip-coverage');
            var zipArray = zipString.split(',');

            if (jQuery.inArray(originalSearchValue, zipArray) !== -1)
            {
                var index = jQuery.inArray(originalSearchValue, zipArray);
                dealerCount = 1;
                jQuery('.js-searhed-zipcode').text(originalSearchValue);
                jQuery(this).removeClass('hidden');
                 jQuery('#js-map-list-results-headline').removeClass('hidden');
            }
        });
        if (dealerCount === 0) {
            jQuery('#js-map-list-no-results').removeClass('hidden');
        }
    };
} )();
